import { useMutation as e } from "@maat/store-hooks";
import { authApi as t } from "@maat/api-main";
//#region src/phone/usePhoneChallengeMutation.ts
var n = () => e({
	mutationFn: () => t.phoneChallenge(),
	retry: !1
});
//#endregion
export { n as usePhoneChallengeMutation };
